/**
 * Created by codingnuts on 2017/12/27.
 */


/********************************* REGISTER *************************************/

export const ACTION_REGISTER = 'doRegister'; // 注册
export const ACTION_REGISTER_TYPE = 'doRegisterType'; // 注册
export const ACTION_REGISTER_EMAIL = 'doRegister2'; //通过邮箱注册
export const ACTION_REGISTER_NEWEMAIL = 'doRegister2'; //通过邮箱注册
export const ACTION_REGISTER_MOBILE = 'doRegisterByMobile' //通过手机号注册
export const ACTION_CHECK_USERINFO = 'checkUserInfo'; //检查用户名信息是否重复
export const ACTION_SEND_MOBILE_NUM = 'sendMobileNum'; //发送手机号
export const ACTION_BIND_THIRDPARTY = 'bindThirdparty'; /* 第三方绑定账号 */
export const ACTION_THIRDPARTY_LOGIN = 'thirdpartyLogin';


// WEBPACK FOOTER //
// ./src/components/work/register/common/interfaces.js